import { ColumnSortType, TableColumnTypes } from '../../../../model/table.model';


export const tableHeaders = [
  {
    value: 'name',
    sort: ColumnSortType.NONE,
    name: 'Назва',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'olx_status',
    sort: ColumnSortType.NONE,
    name: 'Olx статус',
    type: TableColumnTypes.OLX_STATUS,
    className: 'table-header',
  },
  {
    value: 'created_at',
    sort: ColumnSortType.NONE,
    name: 'Створений',
    type: TableColumnTypes.DATE,
    className: 'table-header',
  },
  // {
  //   value: 'updated_at',
  //   sort: ColumnSortType.NONE,
  //   name: 'Обновлений',
  //   type: TableColumnTypes.DATE,
  //   className: 'table-header',
  // },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions:
      [
        {icon: 'edit', label: 'edit', value: 'EDIT'},
        // { icon: 'delete', label: 'Видалити', value: 'DELETE' },
      ],
    translate: true,
  },
];

export interface Application {
  title: string,
  name: string,
  brief_description: string,
  bg_color: string,
  text_color: string,
  type: string
}

export enum APPLICATION_TYPE {
  POWER_OLX_V2 = 'POWER_OLX_V2',
  OLX = 'OLX_TOOL',
  CHECKBOX = 'CHECKBOX',
  LOGISTIC = 'LOGISTIC',
  RINGOSTAT = 'RINGOSTAT',
  TELEGRAM_BOT = 'TELEGRAM_BOT',
  GEN_AI = 'GEN_AI',
  NEURON_AND_ANOTHER_CRM = 'NEURON_AND_ANOTHER_CRM',
  NOVA_POSHTA = 'NOVA_POSHTA',
  VCHASNO_KASA = 'VCHASNO_KASA',
}
